import { useMemo } from 'react';

import { useGetFilteredAssets, useSetFilterOptions } from '../marketplace/assets/useAssetFilters.ts';
import { useAppSelector } from '../redux/useAppSelector.ts';
import { useAccountsItems } from '../wallets/useAccountsItems.ts';

export function useProfileCollectibles() {
    const pageOwnerId = useAppSelector((s) => s.yatPage.user_id);
    const { accountsFilter, getFilteredByHidden } = useGetFilteredAssets();
    const { data, ...rest } = useAccountsItems({ pageOwnerId, accountsFilter });
    const accounts = data?.pagesData;
    const walletAddresses = accounts?.map((acc) => acc?.address).filter(Boolean);

    const collectibles = accounts?.flatMap((account) => account?.collectibles).filter(Boolean);
    const collectionIds = useMemo(() => {
        const rawCollectionIds = collectibles?.map((asset) => asset?.collection?.id);

        return [...new Set(rawCollectionIds)];
    }, [collectibles]);

    const nftEntries = collectibles ? getFilteredByHidden(collectibles) : [];

    useSetFilterOptions({ walletAddresses, collectionIds });

    return {
        items: nftEntries,
        isLoadingAccounts: rest.isLoading,
        itemCount: collectibles?.length,
        ...rest,
    };
}
